import {
  Box,
  Flex
} from '@chakra-ui/react'
import { GlobeIcon } from 'assets/icons'
import { COLORS } from 'utils/styles'
import { MIN_ZOOM_LEVEL } from 'utils/constants'

export const UsersCount = ({
  visibleMarkersCount,
  showMarkerCount,
  zoom,
  goToMinZoomOut
}) => (
  <Flex
    zIndex={400}
    position="absolute"
    top="5px"
    fontSize="14px"
    fontWeight="bold"
    background={COLORS.gray_op8}
    padding="4px 12px"
    borderRadius="5px"
    left="49%"
    display={showMarkerCount}
    flexDirection="row"
    gap={1}
    data-name="markerCount"
    className="marker-count"
    cursor={parseInt(zoom, 10) === MIN_ZOOM_LEVEL ? 'default' : 'pointer'}
    pointerEvents={parseInt(zoom, 10) === MIN_ZOOM_LEVEL ? 'none' : 'auto'}
    onClick={() => goToMinZoomOut()}
    sx={{
      '@media (max-width: 480px)': {
        left: '45%'
      },
      '@media (max-width: 800px)': {
        left: '45%'
      }
    }}
  >
    {visibleMarkersCount?.length}
    {
      zoom === '4'
        ? (
          <Box marginTop="1px">
            <GlobeIcon />
          </Box>
        )
        : null
    }
  </Flex>
)
